/**
 * ScamBlocker AI Dashboard — i18n (i18next + react-i18next)
 * Dil: localStorage tercihi → navigator.language → 'tr' (fallback).
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import tr from './locales/tr.json';

export const SUPPORTED_LANGS = ['tr', 'en'] as const;
export type AppLang = (typeof SUPPORTED_LANGS)[number];
const STORAGE_KEY = 'app.lang';

function detectLang(): AppLang {
  try {
    const stored = localStorage.getItem(STORAGE_KEY) as AppLang | null;
    if (stored && (SUPPORTED_LANGS as readonly string[]).includes(stored)) return stored;
  } catch {
    /* localStorage erişilemezse yoksay */
  }
  const nav = (typeof navigator !== 'undefined' && navigator.language) || 'tr';
  return nav.toLowerCase().startsWith('en') ? 'en' : 'tr';
}

// <html lang> aktif dille senkron tutulur. index.html'de lang="tr" sabitti;
// UI İngilizce render olduğunda CSS text-transform: uppercase Türkçe kuralla
// çalışıp "Protection" → "PROTECTİON" (noktalı İ) üretiyordu (2026-08-27 saha
// bulgusu). lang senkronuyla her dil kendi büyütme kuralını kullanır.
function syncHtmlLang(lang: string): void {
  try {
    document.documentElement.lang = lang;
  } catch {
    /* SSR/test ortamında document yoksa yoksay */
  }
}

i18n.use(initReactI18next).init({
  resources: {
    tr: { translation: tr },
    en: { translation: en },
  },
  lng: detectLang(),
  fallbackLng: 'tr',
  supportedLngs: SUPPORTED_LANGS as unknown as string[],
  interpolation: { escapeValue: false },
  returnNull: false,
});

syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export function setAppLang(lang: AppLang): void {
  i18n.changeLanguage(lang);
  try {
    localStorage.setItem(STORAGE_KEY, lang);
  } catch {
    /* yoksay */
  }
}

export default i18n;
